// work-phases.api.ts
// Clients HTTP pour les phases de travail d'une unité de travail.
// Swagger : GET/POST /api/work-units/{workUnitId}/work-phases
//           GET/PATCH/DELETE /api/work-units/{workUnitId}/work-phases/{workPhaseId}

import type {
  WorkPhase,
  CreateWorkPhaseRequest,
  UpdateWorkPhaseRequest,
} from "@/domain/types/work-phase";

import apiClient from "./client";

export async function getWorkPhases(workUnitId: string): Promise<WorkPhase[]> {
  const { data } = await apiClient.get<WorkPhase[] | { items: WorkPhase[] }>(
    `/api/work-units/${workUnitId}/work-phases`,
  );
  return Array.isArray(data) ? data : (data.items ?? []);
}

export async function createWorkPhase(
  workUnitId: string,
  body: CreateWorkPhaseRequest,
): Promise<WorkPhase> {
  const { data } = await apiClient.post<WorkPhase>(
    `/api/work-units/${workUnitId}/work-phases`,
    body,
  );
  return data;
}

export async function updateWorkPhase(
  workUnitId: string,
  workPhaseId: string,
  body: UpdateWorkPhaseRequest,
): Promise<WorkPhase> {
  const { data } = await apiClient.patch<WorkPhase>(
    `/api/work-units/${workUnitId}/work-phases/${workPhaseId}`,
    body,
    { headers: { "Content-Type": "application/merge-patch+json" } },
  );
  return data;
}

export async function archiveWorkPhase(
  workUnitId: string,
  workPhaseId: string,
): Promise<void> {
  await apiClient.delete(
    `/api/work-units/${workUnitId}/work-phases/${workPhaseId}`,
  );
}
